import { Logger } from "@noli/core";

import Icon from "@/components/Icon";
import AcceleratePayment from "@/modules/payment/AcceleratePayment";
import { genBlock } from "@/utils/bem";
import { Box, Center, chakra, ChakraProps } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { accelerationStore } from "@/stores/acceleration";
import { ReactComponent as RocketSvg } from "@/assets/icons/rocket.svg";
import "./accelerate-status.scss";
import { SafeOp, taskPollingPool } from "@/utils/safeOp";
import { ACCELERATE_PATIENCE } from "@/utils/constants";
import { batchTaskPollingPool } from "@/utils/batchTask";

const block = genBlock("c-accelerate-status");

const goldGradient = `linear-gradient(90deg, #F0BF68, #F9E5AE)`;
const goldBorder: ChakraProps = {
  _before: {
    content: "''",
    bg: goldGradient,
    pos: "absolute",
    left: 0,
    top: 0,
  },
  bg: goldGradient,
};
const AccelerateStatus: React.FC = () => {
  const { paymentModalOpen: open, setPaymentModalOpen: setOpen, isVip } = accelerationStore;

  function handleClose() {
    setOpen(false);
  }

  async function handlePaySuccess() {
    handleClose();
    // if (!isVip) {
    //   // [...taskPollingPool.elements].forEach((task) => {
    //   //   const setForceGuest = (reason: any) => {
    //   //     Logger.debug(`>> setForceGuest : ${reason}`);
    //   //     task.forceGuest = true;
    //   //   };
    //   //   // 跳过非 kafka 任务
    //   //   if (!task.isKafka) return setForceGuest("not kafka");
    //   //   // 跳过非等待中的任务
    //   //   if (task.status !== "pending") return setForceGuest("not pending");
    //   //   // 跳过顺位足够靠前的任务
    //   //   if (task.pending <= -1) return setForceGuest("small pending");
    //   //   const { uri, data } = task.taskPack;
    //   //   // 创建新任务并返回创建结果，如果不成功，要用 forceGuest 强制继续使用免费通道
    //   //   SafeOp.createKafkaTask(uri, data, async (e) => setForceGuest(e))
    //   //     .then(async (taskId) => {
    //   //       if (!taskId) return "failed to get `taskId`";
    //   //       const status = await SafeOp.getKafkaStatus(taskId, false);
    //   //       if (!status) return "failed to get new `status`";
    //   //       if (status.status === "exception") return "status is `exception`";
    //   //       /**
    //   //        * 只有当切换任务通道后，满足下列三种情况之一：
    //   //        *
    //   //        * 1. 已经完成
    //   //        * 2. 已经开始工作
    //   //        * 3. pending 足够小
    //   //        *
    //   //        * 时，才去切换任务通道
    //   //        */
    //   //       if (
    //   //         status.status === "finished" ||
    //   //         status.status === "working" ||
    //   //         status.pending <= task.pending + ACCELERATE_PATIENCE
    //   //       ) {
    //   //         task.updateTaskKey(taskId);
    //   //         return;
    //   //       }
    //   //       return `no need to switch to status : ${JSON.stringify(status)}`;
    //   //     })
    //   //     .then((message) => {
    //   //       if (message) {
    //   //         setForceGuest(message);
    //   //       }
    //   //     });
    //   // });
    //   if (batchTaskPollingPool.size) {
    //     /** 重新获取一下状态 */
    //     batchTaskPollingPool.forEach((batchTaskPolling) => {
    //       batchTaskPolling.refresh();
    //     });
    //   }
    // }
    accelerationStore.afterPayment();
  }

  return (
    <>
      <Box className={block()} onClick={() => setOpen(true)} {...goldBorder}>
        <Box bg="#323232" w="100%" h="100%" p="4px 8px" rounded="3px">
          <Center w="100%" h="100%" whiteSpace="nowrap" className={block({ e: "text-wrap" })}>
            {isVip ? (
              <>
                <chakra.span mr="3px">算力加速中</chakra.span>
                <Icon svg={RocketSvg} squared={false} />
              </>
            ) : (
              <>
                <Icon svg={RocketSvg} squared={false} />
                <chakra.span ml="3px">获得加速</chakra.span>
              </>
            )}
          </Center>
        </Box>
      </Box>
      <AcceleratePayment open={open} onClose={handleClose} onPaySuccess={handlePaySuccess} />
    </>
  );
};

export default observer(AccelerateStatus);
